import Header from '../Components/Header';
import Footer from '../Components/Footer';
import Sector from '../Components/Sector';
import RadioInline from '../Components/RadioInline';
import Checkbox from '../Components/Checkbox';
import CustomCheckbox from '../Components/CustomeCheckbox';
import MultiRadio from '../Components/MultiRadio';
import Dropdown from '../Components/Dropdown';
import Radio from '../Components/Radio';
import Text from '../Components/Text';
import MultiDropdown from '../Components/MultiDropdown';
import React, {
    Component
} from 'react';
import {
    useNavigate,
    useLocation
} from 'react-router-dom';
import {
    useGlobalState
} from '../Networks/QuestionState';

function QuestionPage2() {
    const navigator = useNavigate();
    const location = useLocation();
    const [sample] = useGlobalState('sample');
    // console.log('sample 2 :>> ', sample);

    return <NavigationRoute navigation = {
        navigator
    }
    sector_id = {
        location.state.sector_id
    }
    sector_name = {
        location.state.sector_name
    }
    subSector_id = {
        location.state.subsector_id
    }
    subSector_name = {
        location.state.subsector_name
    }
    choice = {
        location.state.choice
    }
    sample = {
        sample
    } > < /NavigationRoute>
}

class NavigationRoute extends Component {
    //  [sample] = useGlobalState('sample');


    constructor() {
        super();

        this.state = {
            custDropAns: null,
            multidropAns: ['1 Least important', '2', '3', '4', '5', '6', '7', '8 Most important'],
            error2: false,
            error3: false,
            error4: false,
            error5: false,
            error6: false,
            error7: false,
            error8: false,
            error9: false,
            error10: null,
            error11: null,
            error12: false,
            error26: false,
            error27: false,
            error28: false,
            error29: false,
            error30: false,
            error13: null,
            error31: false,
            error32: false,
            error33: false,
            error34: false,
            error35: false,
            error36: false,
            error37: false,
            error38: false,
            error39: false,
            error40: false,
            error43: false,
            error44: false,
            error45: false,
            ans2: '',
            ans3: [],
            ans4: '',
            ans5: '',
            ans6: '',
            ans7: '',
            ans8: '',
            ans9: '',
            ans10: '',
            ans11: '',
            ans12: '',
            ans26: '',
            ans27: '',
            ans28: '',
            ans29: '',
            ans30: '',
            ans13: '',
            ans31: '',
            ans32: '',
            ans33: '',
            ans34: '',
            ans35: '',
            ans36: '',
            ans37: '',
            ans38: '',
            ans39: '',
            ans40: '',
            ans43: '',
            ans44: '',
            ans45: '',

        }
        this.onTapped = this.onTapped.bind(this);
        this.defaultOnTapped = this.defaultOnTapped.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }



    // error handling click event
    defaultOnTapped = (obj) => {
        console.log("CHECK THE OBJECT");
        console.log(obj);
        if (obj.name === "Question2") {
            this.setState({
                ans2: obj.value,
                error2: obj.value.length !== 0 ? false : true
            })
            //  console.log('Question2 ans', this.state.error3, this.state.ans2);
        } else if (obj.name === "Question3") {
            this.setState({
                ans3: obj.value,
                error3: obj.value !== '' ? false : true
            })
            //  console.log('Question2 ans', this.state.error3, this.state.ans3);
        } else if (obj.name === "Question4") {
            this.setState({
                ans4: obj.value,
                error4: obj.value !== '' ? false : true
            })
            //  console.log('Question2 ans', this.state.error3, this.state.ans4);
        } else if (obj.name === "Question5") {
            let answerList = obj.value
            let checkedAnswers = answerList.filter((item) => item.name != null)
            this.setState({
                ans5: obj.value,
                error5: answerList.length === checkedAnswers.length ? false : true
            })
        } else if (obj.name === "Question6") {
            let answerList = obj.value
            let checkedAnswers = answerList.filter((item) => item.name != null)


            this.setState({
                multidropAns: checkedAnswers
            })

            this.setState({
                ans6: obj.value,
                error6: answerList.length === checkedAnswers.length ? false : true,
                // multidropAns: newlist
            })
        } else if (obj.name === "Question7") {
            let err = obj.value !== '' ? false : true;
            this.setState({
                ans7: obj.value,
                erro7: err
            })
        } else if (obj.name === "Question8") {
            this.setState({
                ans8: obj.value,
                error8: obj.value !== '' ? false : true
            })
            // console.log('Question2 ans', this.state.error3, this.state.ans2);
        } else if (obj.name === "Question9") {
            this.setState({
                ans9: obj.value,
                error9: obj.value !== '' ? false : true
            })
            // console.log('Question2 ans', this.state.error3, this.state.ans2);
        } else if (obj.name === "Question10") {
            this.setState({
                ans10: obj.value,
                error10: obj.value !== '' ? false : true
            })
            // console.log('Question2 ans', this.state.error3, this.state.ans2);
        } else if (obj.name === "Question12") {
            this.setState({
                ans12: obj.value,
                error12: obj.value !== '' ? false : true
            })
            // console.log('Question2 ans', this.state.error3, this.state.ans2);
        }

        else if (obj.name === "Question26") {
            this.setState({
                ans26: obj.value,
                error26: obj.value !== '' ? false : true
            })
            // console.log('Question2 ans', this.state.error3, this.state.ans2);
        }

        else if (obj.name === "Question27") {
            this.setState({
                ans27: obj.value,
                error27: obj.value !== '' ? false : true
            })
        } else if (obj.name === "Question28") {
            this.setState({
                ans28: obj.value,
                error28: obj.value !== '' ? false : true
            })
        } else if (obj.name === "Question29") {
            this.setState({
                ans29: obj.value,
                error29: obj.value !== '' ? false : true
            })
        } 

        else if (obj.name === "Question30") {
            this.setState({
                ans30: obj.value,
                error30: obj.value !== '' ? false : true
            })
            // console.log('Question2 ans', this.state.error3, this.state.ans2);
        }


        else if (obj.name === "Question13") {
            this.setState({
                ans13: obj.value,
                error13: obj.value !== '' ? false : true
            })
            // console.log('Question2 ans', this.state.error3, this.state.ans2);
        }
        // console.log('Question2 ans', this.state.error3, this.state.ans2);


        else if (obj.name === "Question31") {
            this.setState({
                ans31: obj.value,
                error31: obj.value !== '' ? false : true
            })
        }
        
        else if (obj.name === "Question32") {
            this.setState({
                ans32: obj.value,
                error32: obj.value !== '' ? false : true
            })
        }
        
        else if (obj.name === "Question33") {
            this.setState({
                ans33: obj.value,
                error33: obj.value !== '' ? false : true
            })
        }
        
        else if (obj.name === "Question34") {
            this.setState({
                ans34: obj.value,
                error34: obj.value !== '' ? false : true
            })
        }
        
        else if (obj.name === "Question35") {
            this.setState({
                ans35: obj.value,
                error35: obj.value !== '' ? false : true
            })
        }
        
        else if (obj.name === "Question36") {
            this.setState({
                ans36: obj.value,
                error36: obj.value !== '' ? false : true
            })
        }
        
        else if (obj.name === "Question37") {
            this.setState({
                ans37: obj.value,
                error37: obj.value !== '' ? false : true
            })
        }
        
        else if (obj.name === "Question38") {
            this.setState({
                ans38: obj.value,
                error38: obj.value !== '' ? false : true
            })
        }
        
        else if (obj.name === "Question39") {
            this.setState({
                ans39: obj.value,
                error39: obj.value !== '' ? false : true
            })
        }
        
        else if (obj.name === "Question40") {
            this.setState({
                ans40: obj.value,
                error40: obj.value !== '' ? false : true
            })
        }

        else if (obj.name === "Question43") {
            this.setState({
                ans43: obj.value,
                error43: obj.value !== '' ? false : true
            })
        }

        else if (obj.name === "Question44") {
            this.setState({
                ans44: obj.value,
                error44: obj.value !== '' ? false : true
            })
        }

        else if (obj.name === "Question45") {
            this.setState({
                ans45: obj.value,
                error45: obj.value !== '' ? false : true
            })
        }
    }


    onTapped = (obj) => {
        if (obj.name === "Question3") {
            this.setState({
                ans3: obj.value,
                error3: obj.value.length !== 0 ? false : true
            })
            //  console.log('Question3 ans', this.state.error3);
        } else if (obj.name === "Question11") {
            // console.log('Question11 ans', obj.value);
            this.setState({
                ans11: obj.value,
                error11: obj.value.length !== 0 ? false : true
            })
            // console.log('Question11 ans', this.state.error11);
        }
    }

    onSubmit = () => {
        // console.log('SUBMIT::GENERAL  DATA --------------------------------------');
        // console.log('ans2,ans3,ans4,ans5,ans6,ans7,ans8,ans9,ans10,ans11,ans12,ans13 :>> ', [this.state.ans2,this.state.ans3,this.state.ans4,this.state.ans5,this.state.ans6,this.state.ans7,this.state.ans8,this.state.ans9,this.state.ans10,this.state.ans11,this.state.ans12,this.state.ans13]);
        // console.log('ERRORS  :>> ', this.state.error2, this.state.error3 , this.state.error4 , this.state.error5 , this.state.error6 , this.state.error7 ,  this.state.error8 ,this.state.error9 , this.state.error10, this.state.error11,this.state.error12 ,  this.state.error13 );
        // console.log('v2 ', v2);
        let answerList = this.state.ans5 || new Array(10)
        let checkedAnswers = answerList.filter((item) => item.name != null)

        let answerList6 = this.state.ans6 || new Array(10)
        let checkedAnswers6 = answerList.filter((item) => item.name != null)

        console.log("CHECKING ANSWER 4 IS EMPTY OR NOT");
        console.log(typeof(this.state.ans4));
        console.log("Content is: "+this.state.ans4);
        console.log(this.state.ans4.length);



        this.setState({
            error2: this.state.ans2.length !== 0 ? false : true,
            error3: this.state.ans3.length !== 0 ? false : true,
            error4: this.state.ans4.length !== 0 ? false : true,
            error5: answerList.length === checkedAnswers.length ? false : true,
            error6: answerList6.length === checkedAnswers6.length ? false : true,
            error7: this.state.ans7 !== '' ? false : true,
            error8: this.state.ans8.length !== 0 ? false : true,
            error9: this.state.ans9.length !== 0 ? false : true,
            error10: this.state.ans10.length !== 0 ? false : true,
            error11: this.state.ans11.length !== 0 ? false : true,
            error12: this.state.ans12.length !== 0 ? false : true,
            error26: this.state.ans26.length !== 0 ? false : true,
            error27: this.state.ans27.length !== 0 ? false : true,
            error28: this.state.ans28.length !== 0 ? false : true,
            error29: this.state.ans29.length !== 0 ? false : true,
            error30: this.state.ans30.length !== 0 ? false : true,
            error13: this.state.ans13.length !== 0 ? false : true,
            error31: this.state.ans31.length !== 0 ? false : true,
            error32: this.state.ans32.length !== 0 ? false : true,
            error33: this.state.ans33.length !== 0 ? false : true,
            error34: this.state.ans34.length !== 0 ? false : true,
            error35: this.state.ans35.length !== 0 ? false : true,
            error36: this.state.ans36.length !== 0 ? false : true,
            error37: this.state.ans37.length !== 0 ? false : true,
            error38: this.state.ans38.length !== 0 ? false : true,
            error39: this.state.ans39.length !== 0 ? false : true,
            error40: this.state.ans40.length !== 0 ? false : true,
            error43: this.state.ans43.length !== 0 ? false : true,
            error44: this.state.ans44.length !== 0 ? false : true,
            error45: this.state.ans45.length !== 0 ? false : true,

        })



        if(this.state.ans4.length === 0) {
            console.log("CANNOT PROCEED UNTIL 4 IS FILLED");
            console.log(this.state.ans4.length);

            return false;
        }

        if (this.state.ans2.length === 0 
            // || 
            // this.state.error3 || 
            // this.state.error4 || 
            // this.state.error5 || 
            // this.state.error6 || 
            // this.state.error7 || 
            // this.state.error8 || 
            // this.state.error9 || 
            // this.state.error10 || 
            // this.state.error11 || 
            // this.state.error12 || 
            // this.state.error13 || 
            // this.state.error26 || 
            // this.state.error27 || 
            // this.state.error28 || 
            // this.state.error29 || 
            // this.state.error30 || 
            // this.state.error31 || 
            // this.state.error32 || 
            // this.state.error33 || 
            // this.state.error34 || 
            // this.state.error35 || 
            // this.state.error36 || 
            // this.state.error37 || 
            // this.state.error38 || 
            // this.state.error39 || 
            // this.state.error40
            ) {
            console.log('SUBMIT::ERROR FOUND XXX');
            console.log('ERRORS  :>> ', this.state.ans2.length, this.state.error2, this.state.error3 , this.state.error4 , this.state.error5 , this.state.error6 , this.state.error7 , this.state.error8 , this.state.error9 , this.state.error10, this.state.error11, this.state.error12, this.state.error13, this.state.error14, this.state.error15, this.state.error16, this.state.error17, this.state.error18, this.state.error19, this.state.error20, this.state.error21, this.state.error22, this.state.error23, this.state.error24, this.state.error25, this.state.error26, this.state.error27, this.state.error28, this.state.error29, this.state.error30, this.state.error31, this.state.error32, this.state.error33, this.state.error34, this.state.error35, this.state.error36, this.state.error37, this.state.error38, this.state.error39, this.state.error40, this.state.error43, this.state.error44, this.state.error45);

            let answerList = this.state.ans5 || new Array(10)
            let checkedAnswers = answerList.filter((item) => item.name != null)
            // console.log('answerList, checkedAnswers :>> ', answerList, checkedAnswers);
            let answerList6 = this.state.ans6 || new Array(10)
            let checkedAnswers6 = answerList6.filter((item) => item.name != null)

            // console.log('answerList6, checkedAnswers6 :>> ', answerList6, checkedAnswers6);
            this.setState({
                error2: this.state.ans2.length !== 0 ? false : true,
                error3: this.state.ans3.length !== 0 ? false : true,
                error4: this.state.ans4.length !== 0 ? false : true,
                error5: answerList.length === checkedAnswers.length ? false : true,
                error6: answerList6.length === checkedAnswers6.length ? false : true,
                error7: this.state.ans7 !== '' ? false : true,
                error8: this.state.ans8.length !== 0 ? false : true,
                error9: this.state.ans9.length !== 0 ? false : true,
                error10: this.state.ans10.length !== 0 ? false : true,
                error11: this.state.ans11.length !== 0 ? false : true,
                error12: this.state.ans12.length !== 0 ? false : true,
                error26: this.state.ans26.length !== 0 ? false : true,
                error27: this.state.ans27.length !== 0 ? false : true,
                error28: this.state.ans28.length !== 0 ? false : true,
                error29: this.state.ans29.length !== 0 ? false : true,
                error30: this.state.ans30.length !== 0 ? false : true,
                error13: this.state.ans13.length !== 0 ? false : true,
                error31: this.state.ans31.length !== 0 ? false : true,
                error32: this.state.ans32.length !== 0 ? false : true,
                error33: this.state.ans33.length !== 0 ? false : true,
                error34: this.state.ans34.length !== 0 ? false : true,
                error35: this.state.ans35.length !== 0 ? false : true,
                error36: this.state.ans36.length !== 0 ? false : true,
                error37: this.state.ans37.length !== 0 ? false : true,
                error38: this.state.ans38.length !== 0 ? false : true,
                error39: this.state.ans39.length !== 0 ? false : true,
                error40: this.state.ans40.length !== 0 ? false : true,
                error43: this.state.ans43.length !== 0 ? false : true,
                error44: this.state.ans44.length !== 0 ? false : true,
                error45: this.state.ans45.length !== 0 ? false : true,


            })
        } else {
            console.log('SUBMIT::NO ERROR');
            // console.log('ERRORS  :>> ', this.state.error2, this.state.error3 , this.state.error4 , this.state.error5 , this.state.error6 , this.state.error7 ,  this.state.error8 ,this.state.error9 , this.state.error10, this.state.error11,this.state.error12 ,  this.state.error13 );
            // console.log('this.state.ans2.length === 0  :>> ', this.state.ans2.length === 0 );
            // console.log('this.state.ans2 :>> ', this.state.ans2 );

            console.log("THIS IS ANSWER 11 CONTENT");
            console.log(this.state.ans11);

            let answerList = this.state.ans5 || new Array(10)
            let checkedAnswers = answerList.filter((item) => item.name != null)

            let answerList6 = this.state.ans6 || new Array(10)
            let checkedAnswers6 = answerList6.filter((item) => item.name != null)
            this.setState({
                error2: this.state.ans2.length !== 0 ? false : true,
                error3: this.state.ans3.length !== 0 ? false : true,
                error4: this.state.ans4.length !== 0 ? false : true,
                error5: answerList.length === checkedAnswers.length ? false : true,
                error6: answerList6.length === checkedAnswers6.length ? false : true,
                error7: this.state.ans7 !== '' ? false : true,
                error8: this.state.ans8.length !== 0 ? false : true,
                error9: this.state.ans9.length !== 0 ? false : true,
                error10: this.state.ans10.length !== 0 ? false : true,
                error11: this.state.ans11.length !== 0 ? false : true,
                error12: this.state.ans12.length !== 0 ? false : true,
                error26: this.state.ans26.length !== 0 ? false : true,
                error27: this.state.ans27.length !== 0 ? false : true,
                error28: this.state.ans28.length !== 0 ? false : true,
                error29: this.state.ans29.length !== 0 ? false : true,
                error30: this.state.ans30.length !== 0 ? false : true,
                error13: this.state.ans13.length !== 0 ? false : true,
                error31: this.state.ans31.length !== 0 ? false : true,
                error32: this.state.ans32.length !== 0 ? false : true,
                error33: this.state.ans33.length !== 0 ? false : true,
                error34: this.state.ans34.length !== 0 ? false : true,
                error35: this.state.ans35.length !== 0 ? false : true,
                error36: this.state.ans36.length !== 0 ? false : true,
                error37: this.state.ans37.length !== 0 ? false : true,
                error38: this.state.ans38.length !== 0 ? false : true,
                error39: this.state.ans39.length !== 0 ? false : true,
                error40: this.state.ans40.length !== 0 ? false : true,
                error43: this.state.ans43.length !== 0 ? false : true,
                error44: this.state.ans44.length !== 0 ? false : true,
                error45: this.state.ans45.length !== 0 ? false : true,

            })

            // SEND ANSWERS TO THE NEXT PAGE


            let GcsiPageAnswers = {
                q1: this.props.sector_name,
                subSector: this.props.subSector_name,
                q2: this.state.ans2,
                q3: this.state.ans3.map((item) => item.value),
                q4: this.state.ans4,
                q5: this.state.ans5.map((item) => item.value),
                q6: this.state.ans6.map((item) => item.value),
                q7: this.state.ans7,
                q8: this.state.ans8,
                q9: this.state.ans9,
                q10: this.state.ans10,
                q11: this.state.ans11,
                q12: this.state.ans12,
                q26: this.state.ans26,
                q27: this.state.ans27,
                q28: this.state.ans28,
                q29: this.state.ans29,
                q30: this.state.ans30,
                q13: this.state.ans13,
                q31: this.state.ans31,
                q32: this.state.ans32,
                q33: this.state.ans33,
                q34: this.state.ans34,
                q35: this.state.ans35,
                q36: this.state.ans36,
                q37: this.state.ans37,
                q38: this.state.ans38,
                q39: this.state.ans39,
                q40: this.state.ans40,
                q43: this.state.ans43,
                q44: this.state.ans44,
                q45: this.state.ans45
            }

            console.log('2. GcsiPageAnswers', GcsiPageAnswers)
            this.props.navigation('/survey/question3', {
                state: {
                    GcsiPageAnswers
                }
            })
        }
    }




    render() {
        console.log('CHOICEAs', this.props)

        let sector_name = this.props.sector_name || 'My sector BANK';
        let subSector_name = this.props.subSector_name || "My Sub Sector";
        let sector_id = this.props.sector_id || 1;

        // console.log('this.state.multidropAns :>> ', this.state.multidropAns);
        let question = this.props.sample.map((data) => {
            
            let id = data.id;

            console.log(id);

            if ((id >= 2 && id <= 13) || (id >= 26 && id <= 45)) {
                let question = data.question
                let answers = data.answers
                if (id === 2) {
                    let answer_title = {
                        'begin': 'Totally dissatisfied',
                        'end': 'Totally satisfied'
                    }
                    return ( <
                        RadioInline onValueChange = {
                            this.defaultOnTapped
                        }
                        errorState = {
                            this.state.error2
                        }
                        selected_company = {
                            this.state.company_name
                        }
                        sector = {
                            subSector_name
                        }
                        question = {
                            question
                        }
                        questionName = {
                            'Question2'
                        }
                        answers = {
                            answers
                        }
                        begin = {
                            answer_title.begin
                        }
                        end = {
                            answer_title.end
                        }
                        sameName = {
                            id
                        }
                        key = {
                            2
                        } >
                        <
                        /RadioInline>
                    );

                } else if (id === 3) {
                    let new_answers = answers.filter((answerOne) => {
                        if (answerOne.sector_id === sector_id && answerOne.choice === this.props.choice) {
                            
                            console.log(answerOne);
                            
                            if(answerOne.answer_title !== null) {
                                if(answerOne.answer_title === subSector_name) {
                                    return true;
                                } else {
                                    return false;
                                }
                            } else {
                                return true;
                            }

                        } else return false;
                    })
                    // console.log('new_answers :>> ', new_answers);
                    let sector_title = {
                        'BANKING': "BANKS",
                        "OTHERS": "COMPANIES",
                        'HOSPITALITY': "HOTELS/RESORTS",
                        'HEALTHCARE': "HOSPITALS/CLINICS",
                        "RETAIL MALLS": "RETAIL OUTLETS/SHOPPING MALLS",
                        "PUBLIC INSTITUTIONS": "ORGANIZATIONS"
                    }
                    let company_types = {
                        'BANKING': 'bank',
                        'TELECOMS': 'network'
                    }

                    return <CustomCheckbox
                    defaultValue = {
                        this.state.ans3
                    }
                    defaultState = {
                        true
                    }
                    onValueChange = {
                        this.onTapped
                    }
                    errorState = {
                        this.state.error3
                    }
                    sector = {
                        subSector_name
                    }
                    question = {
                        question
                    }
                    company_type = {
                        company_types[sector_name.toUpperCase()] ? company_types[sector_name.toUpperCase()] : 'company'
                    }
                    sector_title = {
                        sector_title[sector_name.toUpperCase()] ? sector_title[sector_name.toUpperCase()] : 'COMPANIES'
                    }
                    questionName = {
                        'Question3'
                    }
                    answers = {
                        new_answers
                    }
                    key = {
                            3
                        } >
                        <
                        /CustomCheckbox>
                } else if (id === 4) {

                    let selected_companies = {
                        'BANKING': "BANKS",
                        "OTHERS": "COMPANIES",
                        'HOSPITALITY': "HOTELS/RESORTS",
                        'HEALTHCARE': "HOSPITALS/CLINICS",
                        "RETAIL MALLS": "RETAIL OUTLETS/SHOPPING MALLS",
                        "PUBLIC INSTITUTIONS": "ORGANIZATIONS"
                    }

                    let company_types = {
                        'BANKING': 'bank',
                        'TELECOMS': 'network'
                    }

                    return <Radio
                    onValueChange = {
                        this.defaultOnTapped
                    }
                    errorState = {
                        this.state.error4
                    }
                    question = {
                        question
                    }
                    questionName = {
                        'Question4'
                    }
                    answers = {
                        this.state.ans3
                    }
                    sameName = {
                        id
                    }
                    company_type = {
                        company_types[sector_name.toUpperCase()] ? company_types[sector_name.toUpperCase()] : 'company'
                    }
                    selected_companies = {
                        selected_companies[sector_name.toUpperCase()] ? selected_companies[sector_name.toUpperCase()] : 'company'
                    }
                    sector = {
                        subSector_name
                    }
                    key = {
                            4
                        } >
                        <
                        /Radio>

                } else if (id === 5) {
                    let answer_title = {
                        'begin': 'Totally dissatisfied',
                        'end': 'Totally satisfied'
                    }
                    return <MultiRadio
                    onValueChange = {
                        this.defaultOnTapped
                    }
                    errorState = {
                        this.state.error5
                    }
                    selected_company = {
                        this.state.ans4
                    }
                    question = {
                        question
                    }
                    questionName = {
                        'Question5'
                    }
                    answers = {
                        answers
                    }
                    begin = {
                        answer_title.begin
                    }
                    end = {
                        answer_title.end
                    }
                    key = {
                            5
                        } >
                        <
                        /MultiRadio>
                } else if (id === 6) {
                    return <MultiDropdown
                    onValueChange = {
                        this.defaultOnTapped
                    }
                    errorState = {
                        this.state.error6
                    }
                    data = {
                        this.state.custDropAns || this.state.multidropAns
                    }
                    selected_company = {
                        this.state.ans4
                    }
                    question = {
                        question
                    }
                    questionName = {
                        'Question6'
                    }
                    answers = {
                        answers
                    }
                    key = {
                            6
                        } >
                        <
                        /MultiDropdown>
                } else if (id === 7) {
                    return <Text
                    onValueChange = {
                        this.defaultOnTapped
                    }
                    errorState = {
                        this.state.error7
                    }
                    sector = {
                        subSector_name
                    }
                    question = {
                        question
                    }
                    questionName = {
                        'Question7'
                    }
                    defaultValue = {
                        this.state.ans7
                    }
                    key = {
                            7
                        } >
                        <
                        /Text>
                } else if (id === 8) {
                    let answer_title = {
                        'begin': 'I prefer a no frills, lowest price service',
                        'end': 'I prefer excellent service, even if it costs more'
                    }
                    return ( <
                        RadioInline onValueChange = {
                            this.defaultOnTapped
                        }
                        errorState = {
                            this.state.error8
                        }
                        selected_company = {
                            this.state.ans4
                        }
                        sector = {
                            sector_name
                        }
                        question = {
                            question
                        }
                        questionName = {
                            'Question8'
                        }
                        answers = {
                            answers
                        }
                        begin = {
                            answer_title.begin
                        }
                        end = {
                            answer_title.end
                        }
                        sameName = {
                            id
                        }
                        key = {
                            8
                        } >
                        <
                        /RadioInline>
                    );
                } else if (id === 9) {
                    let answer_title = {
                        'begin': 'Extremely dissatisfied',
                        'end': 'Extremely satisfied'
                    }
                    return ( <
                        RadioInline onValueChange = {
                            this.defaultOnTapped
                        }
                        errorState = {
                            this.state.error9
                        }
                        selected_company = {
                            this.state.ans4
                        }
                        sector = {
                            sector_name
                        }
                        question = {
                            question
                        }
                        questionName = {
                            'Question9'
                        }
                        answers = {
                            answers
                        }
                        begin = {
                            answer_title.begin
                        }
                        end = {
                            answer_title.end
                        }
                        sameName = {
                            id
                        }
                        key = {
                            9
                        } >
                        <
                        /RadioInline>
                    );
                } else if (id === 10) {
                    let answer_title = {
                        'begin': 'Very unlikely',
                        'end': 'Very likely'
                    }
                    return ( <
                        RadioInline onValueChange = {
                            this.defaultOnTapped
                        }
                        errorState = {
                            this.state.error10
                        }
                        selected_company = {
                            this.state.ans4
                        }
                        sector = {
                            sector_name
                        }
                        question = {
                            question
                        }
                        questionName = {
                            'Question10'
                        }
                        answers = {
                            answers
                        }
                        begin = {
                            answer_title.begin
                        }
                        end = {
                            answer_title.end
                        }
                        sameName = {
                            id
                        }
                        key = {
                            10
                        } >
                        <
                        /RadioInline>
                    );
                    
                } 
                
                // QUESTIONS TO ASK BASED ON SUBSECTOR

                // Leisure, parks, resorts, hotels
                else if (id === 11 && subSector_name === "Hotels, Parks & Resorts") {

                    return <Radio
                    onValueChange = {
                        this.onTapped
                    }
                    errorState = {
                        this.state.error11
                    }
                    sector = {
                        subSector_name
                    }
                    question = {
                        question
                    }
                    questionName = {
                        'Question11'
                    }
                    answers = {
                        answers
                    }
                    key = {
                            11
                        } >
                        <
                        /Radio>
                } else if (id === 12 && subSector_name === "Bars, Lounges & Eateries") {
                    return <Checkbox
                    onValueChange = {
                        this.defaultOnTapped
                    }
                    errorState = {
                        this.state.error12
                    }
                    question = {
                        question
                    }
                    questionName = {
                        'Question12'
                    }
                    answers = {
                        answers
                    }
                    sameName = {
                        id
                    }
                    sector = {
                        subSector_name
                    }
                    key = {
                            12
                        } >
                        <
                        /Checkbox>
                } 
                
                else if (id === 26 && subSector_name === "Banking") {
                    return <Radio
                    onValueChange = {
                        this.defaultOnTapped
                    }
                    errorState = {
                        this.state.error26
                    }
                    question = {
                        question
                    }
                    questionName = {
                        'Question26'
                    }
                    answers = {
                        answers
                    }
                    sameName = {
                        id
                    }
                    sector = {
                        subSector_name
                    }
                    key = {
                            26
                        } >
                        <
                        /Radio>
                } 


                else if (id === 27 && subSector_name === "Fintech") {
                    return <Radio
                    onValueChange = {
                        this.defaultOnTapped
                    }
                    errorState = {
                        this.state.error27
                    }
                    question = {
                        question
                    }
                    questionName = {
                        'Question27'
                    }
                    answers = {
                        answers
                    }
                    sameName = {
                        id
                    }
                    sector = {
                        subSector_name
                    }
                    key = {
                            27
                        } >
                        <
                        /Radio>
                } else if (id === 28 && subSector_name === "GSM Provider") {
                    return (
                    <Radio
                    onValueChange={this.defaultOnTapped}
                    errorState={this.state.error28}
                    question={question}
                    questionName={'Question28'}
                    answers={answers}
                    sameName={id}
                    sector={sector_name}
                    key={28}
                    />
                    );
                    } else if (id === 29 && subSector_name === "Internet Service Providers") {
                    return (
                    <Radio
                    onValueChange={this.defaultOnTapped}
                    errorState={this.state.error29}
                    question={question}
                    questionName={'Question29'}
                    answers={answers}
                    sameName={id}
                    sector={sector_name}
                    key={29}
                    />
                    );
                    } else if (id === 30 && subSector_name === "General Insurance") {
                    return (
                    <Radio
                    onValueChange={this.defaultOnTapped}
                    errorState={this.state.error30}
                    question={question}
                    questionName={'Question30'}
                    answers={answers}
                    sameName={id}
                    sector={sector_name}
                    key={30}
                    />
                    );
                    } else if (id === 31 && subSector_name === "Health Management Organizations (HMO)") {
                    return (
                    <Radio
                    onValueChange={this.defaultOnTapped}
                    errorState={this.state.error31}
                    question={question}
                    questionName={'Question31'}
                    answers={answers}
                    sameName={id}
                    sector={sector_name}
                    key={31}
                    />
                    );
                    } else if (id === 32 && subSector_name === "Private Hospitals") {
                    return (
                    <Radio
                    onValueChange={this.defaultOnTapped}
                    errorState={this.state.error32}
                    question={question}
                    questionName={'Question32'}
                    answers={answers}
                    sameName={id}
                    sector={sector_name}
                    key={32}
                    />
                    );
                    } else if (id === 33 && subSector_name === "Public Hospitals") {
                    return (
                    <Radio
                    onValueChange={this.defaultOnTapped}
                    errorState={this.state.error33}
                    question={question}
                    questionName={'Question33'}
                    answers={answers}
                    sameName={id}
                    sector={sector_name}
                    key={33}
                    />
                    );
                    } else if (id === 34 && subSector_name === "Aviation") {
                    return (
                    <Radio
                    onValueChange={this.defaultOnTapped}
                    errorState={this.state.error34}
                    question={question}
                    questionName={'Question34'}
                    answers={answers}
                    sameName={id}
                    sector={sector_name}
                    key={34}
                    />
                    );
                    } else if (id === 35 && subSector_name === "Inter-state Transport") {
                    return (
                    <Radio
                    onValueChange={this.defaultOnTapped}
                    errorState={this.state.error35}
                    question={question}
                    questionName={'Question35'}
                    answers={answers}
                    sameName={id}
                    sector={sector_name}
                    key={35}
                    />
                    );
                    }  else if (id === 36 && subSector_name === "Intra-city Transport") {
                        return <Radio
                        onValueChange = {
                        this.defaultOnTapped
                        }
                        errorState = {
                        this.state.error36
                        }
                        question = {
                        question
                        }
                        questionName = {
                        'Question36'
                        }
                        answers = {
                        answers
                        }
                        sameName = {
                        id
                        }
                        sector = {
                        sector_name
                        }
                        key = {
                        36
                        } >
                        <
                        /Radio>
                        } else if (id === 37 && subSector_name === "Distribution (Discos)") {
                        return <Radio
                        onValueChange = {
                        this.defaultOnTapped
                        }
                        errorState = {
                        this.state.error37
                        }
                        question = {
                        question
                        }
                        questionName = {
                        'Question37'
                        }
                        answers = {
                        answers
                        }
                        sameName = {
                        id
                        }
                        sector = {
                        sector_name
                        }
                        key = {
                        37
                        } >
                        <
                        /Radio>
                        } else if (id === 38 && subSector_name === "Online Stores") {
                        return <Radio
                        onValueChange = {
                        this.defaultOnTapped
                        }
                        errorState = {
                        this.state.error38
                        }
                        question = {
                        question
                        }
                        questionName = {
                        'Question38'
                        }
                        answers = {
                        answers
                        }
                        sameName = {
                        id
                        }
                        sector = {
                        sector_name
                        }
                        key = {
                        38
                        } >
                        <
                        /Radio>
                        } else if (id === 39 && subSector_name === "Government Agencies") {
                        return <Radio
                        onValueChange = {
                        this.defaultOnTapped
                        }
                        errorState = {
                        this.state.error39
                        }
                        question = {
                        question
                        }
                        questionName = {
                        'Question39'
                        }
                        answers = {
                        answers
                        }
                        sameName = {
                        id
                        }
                        sector = {
                        sector_name
                        }
                        key = {
                        39
                        } >
                        <
                        /Radio>
                        } else if (id === 40 && subSector_name === "Nigeria Missions/Embassies") {
                        return <Radio
                        onValueChange = {
                        this.defaultOnTapped
                        }
                        errorState = {
                        this.state.error40
                        }
                        question = {
                        question
                        }
                        questionName = {
                        'Question40'
                        }
                        answers = {
                        answers
                        }
                        sameName = {
                        id
                        }
                        sector = {
                        sector_name
                        }
                        key = {
                        40
                        } >
                        <
                        /Radio>
                        } else if (id === 45 && subSector_name === "Real Estate") {
                            return <Radio
                            onValueChange = {
                            this.defaultOnTapped
                            }
                            errorState = {
                            this.state.error45
                            }
                            question = {
                            question
                            }
                            questionName = {
                            'Question45'
                            }
                            answers = {
                            answers
                            }
                            sameName = {
                            id
                            }
                            sector = {
                            sector_name
                            }
                            key = {
                            45
                            } >
                            <
                            /Radio>
                            } else if (id === 43 && (subSector_name === "Public universities" || subSector_name === "Private universities")) {
                                return <Radio
                                onValueChange = {
                                this.defaultOnTapped
                                }
                                errorState = {
                                this.state.error43
                                }
                                question = {
                                question
                                }
                                questionName = {
                                'Question43'
                                }
                                answers = {
                                answers
                                }
                                sameName = {
                                id
                                }
                                sector = {
                                sector_name
                                }
                                key = {
                                43
                                } >
                                <
                                /Radio>
                                } else if (id === 44 && subSector_name === "Sports/Gaming") {
                                    
                                    return <Radio
                                    onValueChange = {
                                    this.defaultOnTapped
                                    }
                                    errorState = {
                                    this.state.error44
                                    }
                                    question = {
                                    question
                                    }
                                    questionName = {
                                    'Question44'
                                    }
                                    answers = {
                                    answers
                                    }
                                    sameName = {
                                    id
                                    }
                                    sector = {
                                    sector_name
                                    }
                                    key = {
                                    44
                                    } >
                                    <
                                    /Radio>
                                    } 
                
                
                // END OF SUB SECTOR QUESTIONS
                
                
                else if (id === 13) {
                    return <Dropdown
                    defaultValue = {
                        this.state.ans13
                    }
                    onValueChange = {
                        this.defaultOnTapped
                    }
                    errorState = {
                        this.state.error13
                    }
                    selected_company = {
                        this.state.ans4
                    }
                    question = {
                        question
                    }
                    questionName = {
                        'Question13'
                    }
                    answers = {
                        answers
                    }
                    key = {
                            13
                        } >
                        <
                        /Dropdown>
                }


                console.log("THE BIG ID: " + id);
            } else {
                return null;
            }
            return null;
        });

        const sectorDes = [{
                name: 'Utilities',
                value: 'This section surveys Utilities Sector, including Zoomlion'
            },
            {
                name: 'Healthcare',
                value: 'This section surveys both public and private healthcare facilities'
            },
            {
                name: 'Banking',
                value: 'This section surveys banks licensed by the Bank of Nigeria'
            },
            {
                name: 'Telecoms',
                value: 'This section surveys licensed Telecom companies in Nigeria'
            },
            {
                name: 'Hospitality',
                value: 'This section surveys hotels that are regulated by the Nigeria Tourism Authority'
            },
            {
                name: 'Retail Malls',
                value: 'This section surveys major retail outlets in Nigeria'
            },
            {
                name: 'Public Institutions',
                value: 'This section surveys public sector institutions in Nigeria'
            },
            {
                name: 'Online Businesses',
                value: 'This section surveys popular e-commerce businesses in Nigeria'
            },
            {
                name: 'Transportation',
                value: 'This section surveys ride hailing transport services in Nigeria '
            },
            {
                name: 'Insurance',
                value: 'This section surveys insurance companies regulated by the National Insurance Commission'
            },
            {
                name: 'Oil Marketing Companies',
                value: 'This section surveys the Oil Marketing Companies Sector'
            },
            {
                name: 'Oil Marketing',
                value: 'This section surveys the Oil Marketing Companies Sector'
            },
            {
                name: 'Power',
                value: 'This section surveys the Power Sector'
            },
            {
                name: 'Government Agencies(Public Sector)',
                value: 'This section surveys the Government Agencies(Public Sector)'
            },
            {
                name: 'Financial',
                value: 'This section surveys the Financial Sector'
            },
            {
                name: 'Online Shopping/E-commerce',
                value: 'This section surveys the Online Shopping Sector'
            },
            {
                name: 'Public Sector',
                value: 'This section surveys the Public Sector'
            },
        ]


        const sector_title = subSector_name + ' SUB-SECTOR'
        // const sector_description = sectorDes.filter((item) => item.name === sector_name)


        let subSector_name_short;
        switch (subSector_name) {
            case "Banking":
                subSector_name_short = "banks";
            break;
            case "Fintech":
                subSector_name_short = "fintechs";
            break;
            case "GSM Provider":
                subSector_name_short = "GSM providers";
            break;
            case "Internet Service Providers":
                subSector_name_short = "internet service providers";
            break;
            case "General Insurance":
                subSector_name_short = "general insurance companies";
            break;
            case "Health Management Organizations (HMO)":
                subSector_name_short = "health management organizations";
            break;
            case "Public Hospitals":
                subSector_name_short = "public hospitals";
            break;
            case "Private Hospitals":
                subSector_name_short = "private hospitals";
            break;
            case "Aviation":
                subSector_name_short = "aviation companies";
            break;
            case "Inter-state Transport":
                subSector_name_short = "inter-state transport companies";
            break;
            case "Intra-city Transport":
                subSector_name_short = "intra-city transport companies";
            break;
            case "Distribution (Discos)":
                subSector_name_short = "distribution companies (Discos)";
            break;
            case "Online Stores":
                subSector_name_short = "online stores";
            break;
            case "Government Agencies":
                subSector_name_short = "government agencies";
            break;
            case "Nigeria Missions/Embassies":
                subSector_name_short = "Nigeria missions/embassies";
            break;
            case "Hotels, Parks & Resorts":
                subSector_name_short = "hotels, parks & resorts";
            break;
            case "Bars, Lounges & Eateries":
                subSector_name_short = "bars, lounges & eateries";
            break;
            default:
                subSector_name_short = subSector_name;
            break;
        }
        
        let sector_name_short;
        switch (sector_name) {
            case "Financial":
            sector_name_short = "financial sector";
            break;
            case "Telecoms":
            sector_name_short = "telecoms sector";
            break;
            case "Insurance":
            sector_name_short = "insurance sector";
            break;
            case "Healthcare":
            sector_name_short = "healthcare sector";
            break;
            case "Transportation":
            sector_name_short = "transportation sector";
            break;
            case "Power":
            sector_name_short = "power sector";
            break;
            case "Online Shopping/E-commerce":
            sector_name_short = "online shopping/e-commerce sector";
            break;
            case "Public Sector":
            sector_name_short = "public sector";
            break;
            case "Hospitality":
            sector_name_short = "hospitality sector";
            break;
            default:
            sector_name_short = sector_name;
            break;
        }

        let relation_to_nigeria = "in Nigeria";

        switch (subSector_name) {
            case "Nigeria Missions/Embassies":
                relation_to_nigeria = "of Nigeria";
                break;
            default:
                relation_to_nigeria = "in Nigeria";
                break;
        }
        

        const sector_description = "This section surveys " + subSector_name_short + " operating in the " + sector_name_short + " "+relation_to_nigeria

        // console.log('SECTOR SECTION---------------', sector_name)
        return ( <
            div className = "main-body" >
            <Header key = {
                'header'
            } > < /Header> <
            Sector sector_description = {
                sector_description 
            }
            sector_title = {
                sector_title
            }
            key = {
                'sector'
            } > < /Sector> 
            
            <br></br>
            <div class=' defaultRounded defaultBorder pt-2'><div class='pl-4 pr-4'><p class='small text-justify'> A minimum of 50 responses is required for a company to be featured in the Index, and one can complete the survey for as many sectors as possible. A maximum of five (5) is, however, recommended. </p> </div>  </div>
            
            {
                question
            }


            <
            Footer key = {
                'footer'
            }
            title = {
                'Next'
            }
            onTap = {
                this.onSubmit
            }
            button_state = 'true'
            load = {
                '36%'
            }
            page = {
                3
            } > < /Footer> <
            /div>
        );
    }


}

export default QuestionPage2;